import React, { useEffect, useState } from 'react';

import styles from './styles.styl';
import cn from 'classnames/bind';
import MySurveyItem from 'src/components/MySurveyItem';
import { SurveyTypeEnum } from 'src/utils/enum';
import { IconSearch } from '@consta/uikit/IconSearch';
import { TextField } from '@consta/uikit/TextField';
import { Button } from '@consta/uikit/Button';
import { Combobox } from '@consta/uikit/Combobox';
import { IconFunnel } from '@consta/uikit/IconFunnel';
import { useDispatch, useSelector } from 'react-redux';
import { loadListMySurvey } from 'src/redux/features/surveys/allMySurvey/actions';
import { storageId } from 'src/utils/storage';
import {
  allMySurveyLoadedSelector,
  allMySurveySelector,
} from 'src/redux/features/surveys/allMySurvey/selectors';
import { State } from 'src/redux/reducer';
import { IMySurveyEntity } from 'src/redux/features/surveys/allMySurvey/types';
import { Loader } from '@consta/uikit/Loader';

const cx = cn.bind(styles);

export interface Item {
  label: string;
  id: string | number;
  action?: () => void;
  status?: boolean;
  type?: SurveyTypeEnum;
  reverse?: boolean;
}

export interface IMySurveysProps {}

const MySurveys: React.FC<IMySurveysProps> = () => {
  const dispatch = useDispatch();
  const mySurveys = useSelector((state: State) => allMySurveySelector(state));
  const mySurveysLoaded = useSelector((state: State) =>
    allMySurveyLoadedSelector(state),
  );
  const [filteredList, setFilteredList] = useState<Array<IMySurveyEntity>>([]);
  const [searchValue, setSearchValue] = useState<string | null>(null);
  const [isSortVisible, setIsSortVisible] = useState(false);

  const [typeValue, setTypeValue] = useState<Item | null>(null);
  const [statusValue, setStatusValue] = useState<Item | null>(null);
  const [dateValue, setDateValue] = useState<Item | null>(null);

  useEffect(() => {
    if (mySurveysLoaded) setFilteredList(mySurveys);
  }, [mySurveysLoaded, mySurveys]);

  useEffect(() => {
    if (typeValue?.type === SurveyTypeEnum.SURVEY) setStatusValue(null);
  }, [typeValue, setStatusValue]);

  useEffect(() => {
    if (mySurveys) {
      const data = mySurveys.filter(
        (item) =>
          (!searchValue ||
            item?.name?.toLowerCase().includes(searchValue.toLowerCase())) &&
          (!statusValue ||
            statusValue?.status === undefined ||
            (item?.item?.points >= item?.item?.passingScore ===
              statusValue.status &&
              item?.type === SurveyTypeEnum.TEST)) &&
          (!typeValue ||
            typeValue?.type === undefined ||
            typeValue.type === item.type),
      );

      if (dateValue && dateValue?.reverse) {
        return setFilteredList(data.reverse());
      }
      setFilteredList(data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue, statusValue, typeValue, dateValue, dateValue]);

  const sortCategoryItems: Item[] = [
    {
      label: 'Все категории',
      id: 'allCategory',
    },
    {
      label: 'Опросы',
      id: 'surveys',
      type: SurveyTypeEnum.SURVEY,
    },
    {
      label: 'Тесты',
      id: 'tests',
      type: SurveyTypeEnum.TEST,
    },
  ];

  const sortStatusItems: Item[] = [
    {
      label: 'Все статусы',
      id: 'allStatus',
    },
    {
      label: 'Пройден',
      id: 'true',
      status: true,
    },
    {
      label: 'Не пройден',
      id: 'false',
      status: false,
    },
  ];

  const sortDateItems: Item[] = [
    {
      label: 'От новых к старым',
      id: 'newToOld',
      reverse: false,
    },
    {
      label: 'От старых к новым',
      id: 'oldToNew',
      reverse: true,
    },
  ];

  useEffect(() => {
    dispatch(loadListMySurvey(storageId()));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!mySurveysLoaded) return <Loader className={cx('MySurveys__loader')} />;

  return (
    <div className={cx('MySurveys')}>
      <div className={cx('MySurveys__filter')}>
        <div className={cx('MySurveys__search')}>
          <TextField
            className={cx('MySurveys__search_input')}
            value={searchValue}
            onChange={({ value }) => setSearchValue(value)}
            placeholder="Найти опрос"
            leftSide={IconSearch}
            key="search"
          />
          <Button
            onlyIcon
            iconRight={IconFunnel}
            iconSize="s"
            view="clear"
            onClick={() => setIsSortVisible(!isSortVisible)}
          />
        </div>
        {isSortVisible && (
          <div className={cx('MySurveys__sort')}>
            <Combobox
              placeholder="Все категории"
              items={sortCategoryItems}
              onChange={({ value }) => setTypeValue(value)}
              value={typeValue}
            />
            <Combobox
              placeholder="Все статусы тестов"
              items={sortStatusItems}
              onChange={({ value }) => setStatusValue(value)}
              value={statusValue}
              getItemDisabled={() => typeValue?.type === SurveyTypeEnum.SURVEY}
            />

            <Combobox
              placeholder="От новых к старым"
              items={sortDateItems}
              onChange={({ value }) => setDateValue(value)}
              value={dateValue}
            />
          </div>
        )}
      </div>
      {mySurveysLoaded &&
        filteredList.map((item, index) => (
          <div key={index} className={cx('MySurveys__item')}>
            <MySurveyItem
              survey={item.item}
              name={item.name}
              type={item.type}
            />
          </div>
        ))}
    </div>
  );
};

export default MySurveys;
